import { useQueryActiveCases } from '#entities/ActiveCase';
import { useQueryAircraftStatuses } from '#entities/Aircraft';
import { useQueryHubsResourceReport } from '#entities/Hub';
import { useQueryNewCases } from '#entities/NewCase';
import { useQuerySimpleStatistics } from '#entities/Statistics';
import { useQuerySurgeons } from '#entities/Surgeon';

/**
 * Subscribes the six core live queries for the route's lifetime, keeping their
 * polling alive regardless of what is mounted (results unused).
 *
 * The METAR/TAF subscriptions went away with the aviation-weather feed
 * (TMDXNC-45): no surviving consumer reads them, so polling them would only
 * hit the BE for data nothing renders. `weatherSnapshotApi` is a different API
 * and stays — `domains/events` queries it directly.
 */
export const useLiveDataSubscriptions = (): void => {
  useQueryActiveCases();
  useQueryNewCases();
  useQueryAircraftStatuses();
  useQuerySimpleStatistics();
  useQueryHubsResourceReport();
  useQuerySurgeons();
};
